import "stylesheets/v2/application";
import "../common";
import "javascripts/v2/application";
import "../app.jsx";
